import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusTransition() {
  return <section className="py-10 sm:py-14 relative" data-id="element-76">
      <div className="mx-auto max-w-3xl px-6 lg:px-8 text-center" data-id="element-77">
        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed" data-id="element-78">
          <FadeIn data-id="element-79">
            <p className="text-xl text-slate-100 font-medium" data-id="element-80">
              Pero antes de que decidas, necesito contarte algo.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-81">
            <p data-id="element-82">
              Cuando diseñé este sistema, me di cuenta de que había dos momentos
              específicos donde casi todo el mundo se traba.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-83">
            <p data-id="element-84">
              El primero es{' '}
              <strong className="text-slate-100" data-id="element-85">
                la misma noche que empezás
              </strong>
              . No sabés exactamente qué hacer si tu gato maúlla mientras estás
              ejecutando el protocolo. Estás cansado. Estás medio dormido. Y ahí
              es donde la mayoría improvisa y arruina el avance.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-86">
            <p data-id="element-87">
              El segundo es{' '}
              <strong className="text-slate-100" data-id="element-88">la rutina previa</strong>.
              Sabés que tenés que hacer algo antes de acostarte. Pero sin una
              secuencia clara, cada noche es distinta. Y sin consistencia, el
              sistema no funciona.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-89">
            <p className="text-gold font-medium" data-id="element-90">
              Por eso decidí incluir dos recursos adicionales sin costo extra.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-91">
            <p className="text-slate-100" data-id="element-92">
              No son relleno. Son las dos piezas que hacen que el protocolo
              principal realmente funcione desde la primera noche.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}